import { useQuery } from '@tanstack/vue-query'
import request from '@/core/request'

import { computed, ref } from 'vue'
import { useToast } from '@/ui-runtime/core/composable/use-toast'
import { useRoute } from 'vue-router'

import { H5JumpApp } from '@/core/bridge'
import { RoomLink } from '@/state/const'
import { getRandomRoomId } from '@/service/newindex'
import { trackEvent } from '@/utils/tracking_utils'
import { user } from '@/state/user'
import { useClientCommonUtils } from '../../composable/use-client-common-utils'

type customKey = 'toSend' | 'toRecharge'

// 根据vue文件中的rankTab请求不同的榜单类型
// boxType 0 赠送 1 收到
export const useBox = (uiMeta: any, stages: number[], percents: number[]) => {
  const { $toast } = useToast()
  const formatMethods = useClientCommonUtils()
  const route = useRoute()
  const activity_code = route.meta?.activity_code
  const componentIds = uiMeta.config?.componentIds
  const boxType = ref(0)
  const handleBoxType = (type: number) => {
    boxType.value = type
  }

  const toGift = async () => {
    const res = await getRandomRoomId()
    if (res.data?.room_id) {
      trackEvent(user, 'common_box_btn_click', {
        button_name: boxType.value === 0 ? '去赠送' : '去获得',
        activity_code: activity_code,
      })
      const roomId = res.data.room_id
      H5JumpApp(RoomLink + roomId + (uiMeta.config?.giftConfig || '&giftTabId=1&giftId=-28'))
    } else if (res.msg) {
      $toast.show(res.msg)
    }
  }

  const {
    data: boxData,
    refetch,
    isLoading: isLoadingBoxData,
  } = useQuery({
    queryKey: ['boxData', componentIds, boxType.value, activity_code],
    queryFn: async () => {
      return await request.get(uiMeta.config.getApi, {
        activity_code,
        component_ids: componentIds.join(','),
      })
    },
  })

  const trueServeList = computed(() => {
    return boxType.value === 1 ? boxData.value?.data?.receive_list || [] : boxData.value?.data?.cost_list || []
  })

  const trueScore = computed(() => {
    return boxType.value === 1 ? boxData.value?.data?.current_receive_score_int : boxData.value?.data?.current_cost_score_int
  })

  const showScore = computed(() => {
    return boxType.value === 1 ? boxData.value?.data?.current_receive_score : boxData.value?.data?.current_cost_score
  })

  const fakeLenth = computed(() => {
    if (trueScore.value <= 0) {
      return 0
    }

    if (trueScore.value >= stages[stages.length - 1]) {
      return percents[percents.length - 1] as number
    }

    const index = stages.findIndex((item: any) => item > trueScore.value)
    // 取前一档
    const length = percents[index - 1] as number
    return (length ?? 0) + 60
  })

  const mixBtnPosition = computed(() => {
    return trueServeList.value?.map((item: any, index: number) => {
      return {
        ...item,
        config: uiMeta.layout.btnsConfig[index],
        btnBg: uiMeta.images[`status${item.status}`],
      }
    })
  })

  const totalScore = computed(() => {
    return trueServeList.value?.[trueServeList.value?.length - 1]?.score
  })

  const handleGetReward = async ({ score, status }: { score: number; status: number }) => {
    if (status === 0) {
      $toast.show(uiMeta.config.unReachMsg)
      return
    }

    if (status === 2) {
      $toast.show(uiMeta.config.alreadyGetMsg)
      return
    }

    const res = await request.post(uiMeta.config.receiveApi, {
      score,
      activity_code,
      component_id: componentIds[boxType.value],
    })

    if (res.status === 0) {
      $toast.show(uiMeta.config.getSuccessMsg)
      refetch()
    } else {
      $toast.show(res.data.msg)
    }
  }

  return {
    refetch,
    mixBtnPosition,
    trueScore,
    totalScore,
    handleGetReward,
    isLoadingBoxData,
    boxType,
    handleBoxType,
    customMethod: formatMethods[uiMeta?.config?.formatMethods as customKey],
    fakeLenth,
    showScore,
  }
}
